(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/react/components/start-buttons.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/react/components/start-buttons.js');

'use strict';

const Button = svs.ui.ReactButton;
const StartButtons = () => {
  const handleClick = page => {
    svs.components.analytics.trackEvent({
      category: 'lotto_startPage',
      action: 'CTA_gameEntry',
      opt_label: page
    }, () => {
      const url = page.toLowerCase().replace(/ /g, '-').replace(/ö/g, 'o').replace(/ä/g, 'a');
      svs.utils.url.navigate("lotto/".concat(url));
    });
  };
  return React.createElement("div", {
    className: "start-buttons"
  }, React.createElement("div", {
    className: "buttons-body"
  }, React.createElement(Button, {
    className: "btn btn-lotto",
    onClick: () => handleClick('Andelsspel'),
    type: "button"
  }, "Andelsspel"), React.createElement(Button, {
    className: "btn btn-lotto",
    onClick: () => handleClick('Systemspel'),
    type: "button"
  }, "Systemspel"), React.createElement(Button, {
    className: "btn btn-lotto",
    onClick: () => handleClick('Förläng spel'),
    type: "button"
  }, "F\xF6rl\xE4ng spel"), React.createElement(Button, {
    className: "btn btn-lotto",
    onClick: () => handleClick('Resultat'),
    type: "button"
  }, "Resultat")));
};
setGlobal('svs.lotto.react.components', {
  StartButtons
});

 })(window);